module.exports = __webpack_public_path__ + "img/97.338fc31.png";